import { render, staticRenderFns } from "./TitleCreditName.vue?vue&type=template&id=60f15bf0&scoped=true"
import script from "./TitleCreditName.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleCreditName.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleCreditName.vue?vue&type=style&index=0&id=60f15bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f15bf0",
  null
  
)

export default component.exports